import { Button, FormGroup, Modal } from "react-bootstrap";
import { useRecoilState } from "recoil";
import { hasBillAtom } from "src/atoms";
import { dateFormatUtcToYMD1 } from "src/utils/dateManagement";
import { checkProduct } from "src/utils/storage/product";
import "./ConsoleBill.style.scss";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import PayInfoSection from "./PayInfoSection";
import BillHistorySection from "./BillHistorySection";
import { useTranslation } from "react-i18next";

interface IConsoleBillUIProps {
  serviceList: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  modal: {
    modalCheckConfirmPrice?: boolean;
    modalSubscriptionsActivate?: boolean;
  };
  toggleModalSubscriptionsActivate: () => void;
  toggleModalCheckConfirmPrice: () => void;
  changeNextPayDate: string;
  subscriptionsActivate: () => void;
  currency: string;
  checkConfirmPrice: () => void;
  showCashRequestDel: boolean;
  showCashReqModal: boolean;
  hideCashReqModal: () => void;
  deleteCashReqMsg: string;
  requestCancelCashStatus: () => void;
  inicisData: any;
  requestPay: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const BillUI = ({
  serviceList,
  handleChange,
  modal,
  inicisData,
  requestPay,
  toggleModalSubscriptionsActivate,
  toggleModalCheckConfirmPrice,
  changeNextPayDate,
  subscriptionsActivate,
  currency,
  checkConfirmPrice,
  showCashRequestDel,
  showCashReqModal,
  hideCashReqModal,
  deleteCashReqMsg,
  requestCancelCashStatus,
}: IConsoleBillUIProps) => {
  const [hasBill] = useRecoilState(hasBillAtom);
  const checkProductName = checkProduct("WRAPSODY_ECO");
  const ableEditBtn = false;
  const { t } = useTranslation();
  const changePriceName = (item: any) => {
    const product = getProductFromSessionStorage();
    const priceType = item.priceType;
    if (product === "WRAPSODY") {
      if (priceType === "drive") {
        return "Basic";
      } else if (priceType === "basic") {
        return "Standard";
      } else if (priceType === "basicPlus") {
        return "Standard Plus";
      } else if (priceType === "plus") {
        return "Enterprise";
      } else if (priceType === "plusPlus") {
        return "Enterprise Plus";
      }
    } else {
      return item.priceName;
    }
  };

  return (
    <div className={hasBill ? "content" : "content_noNav"}>
      {hasBill && (
        <h3 className="content__title">
          <p>{t("siteManagement.paymentHistory.title")}</p>
        </h3>
      )}
      <PayInfoSection
        userCashStatus
        serviceList={serviceList}
        nowDate={0}
        nowTime={0}
        isChangePrice
        ableEditBtn={ableEditBtn}
        inicisData={inicisData}
        currency={currency}
        requestPay={requestPay}
        toggleModalSubscriptionsActivate={toggleModalSubscriptionsActivate}
        // toggleModalConfirmPrice={() => {}}
        // toggleModalConfirmUser={toggleModalConfirmUser}
        // toggleModalConfirmPayTerm={() => {}}
        renewSubscriptions={() => {}}
        dateDifference={0}
        serviceUid={""}
        // requestCashStatus
        newDepositName
        showTaxInvoiceFields
        showCashReqModal
        handleChangeTaxInvoice
      />
      <div className="billMgnt">
        {serviceList !== undefined && serviceList.length > 0 && (
          <BillHistorySection serviceList={serviceList} />
        )}
        {serviceList !== undefined &&
          serviceList.length > 0 &&
          showCashRequestDel && (
            <Modal
              show={showCashReqModal}
              onHide={hideCashReqModal}
              className="confirm__period"
              style={{ opacity: 1 }}
            >
              <Modal.Header>
                <Modal.Title>{t("cashStatus.removePayment")}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <span>{t("cashStatus.removeModal.removePaymentReason")}</span>
                <input
                  id="deleteCashReqMsg"
                  name="deleteCashReqMsg"
                  value={deleteCashReqMsg}
                  type="text"
                  autoFocus={true}
                  placeholder={t("cashStatus.removeModal.removePaymentMsg")}
                  className="form-control mg mt-10"
                  onChange={handleChange}
                />
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn btn-gray" onClick={hideCashReqModal}>
                  {t("common.cancelBtn")}
                </Button>
                <Button
                  className="btn btn-green"
                  onClick={requestCancelCashStatus}
                >
                  {t("common.okBtn")}
                </Button>
              </Modal.Footer>
            </Modal>
          )}
      </div>

      {modal?.modalCheckConfirmPrice && (
        <Modal
          show={modal.modalCheckConfirmPrice}
          onHide={toggleModalCheckConfirmPrice}
          className="confirm__period"
          style={{ opacity: 1 }}
        >
          <Modal.Body>
            <FormGroup className="mg mb-0">
              {t("siteManagement.notice.comfirmPay")}
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-gray"
              onClick={toggleModalCheckConfirmPrice}
            >
              {t("common.cancelBtn")}
            </Button>
            <Button
              className="btn btn-green"
              onClick={(e) => {
                e.preventDefault();
                checkConfirmPrice();
              }}
            >
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {modal?.modalSubscriptionsActivate && (
        <Modal
          show={modal.modalSubscriptionsActivate}
          onHide={toggleModalSubscriptionsActivate}
          className="confirm__period"
          style={{ opacity: 1 }}
        >
          <Modal.Header>
            <Modal.Title>{t("siteManagement.notice.resubscribe1")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup className="mg mb-0">
              {t("siteManagement.notice.resubscribe2", {
                0: dateFormatUtcToYMD1(changeNextPayDate),
              })}
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-gray"
              onClick={toggleModalSubscriptionsActivate}
            >
              {t("common.cancelBtn")}
            </Button>
            <Button className="btn btn-green" onClick={subscriptionsActivate}>
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default BillUI;
